// @tCentro/Store/Reducer/BrandProductFamiliesSelectors.ts
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";

export const getBrandProductFamilies = (state: CustomApplicationState, brandId?: string) =>
    brandId ? state.t_components?.CENProductFamiliesData?.byBrandId?.[brandId] : undefined;